export default "__VITE_ASSET__DQiqP75x__"